import {
  createEternalProjectSchema,
  type EternalChallengeWithUserState,
  type UserEternalChallengeDetails,
} from '../lib';
import { z } from 'zod';

export type RetrieveEternalChallengeStateResponse =
  EternalChallengeWithUserState;

export const createEternalChallengeForUserSchema = z.object({}).strict();

export type CreateEternalChallengeForUserBody = z.infer<
  typeof createEternalChallengeForUserSchema
>;

export type CreateEternalChallengeForUserResponse = {
  message: string;
};

export const submitProjectDetailsSchema = z
  .object({
    targetAudience: z
      .string()
      .min(1, 'Please complete this question.')
      .max(1200, 'Please keep this under 1200 characters.'),
    teamSuitability: z
      .string()
      .min(1, 'Please complete this question.')
      .max(1200, 'Please keep this under 1200 characters.'),
    startedAndPriorities: z
      .string()
      .min(1, 'Please complete this question.')
      .max(1200, 'Please keep this under 1200 characters.'),
    raised: z
      .string()
      .min(1, 'Please complete this question.')
      .max(1200, 'Please keep this under 1200 characters.'),
  })
  .strict();

export type SubmitProjectDetailsBody = z.infer<
  typeof submitProjectDetailsSchema
>;

export type SubmitProjectDetailsResponse = {
  success: boolean;
};

export const submitVideoUpdateSchema = z
  .object({
    videoUrl: z
      .string()
      .url('Please provide a valid full URL')
      .refine(
        (url) => {
          const lowerUrl = url.toLowerCase();
          return (
            lowerUrl.includes('youtube.com') ||
            lowerUrl.includes('youtu.be') ||
            lowerUrl.includes('loom.com')
          );
        },
        {
          message: 'Only YouTube and Loom links are allowed',
        },
      ),
  })
  .strict();

export type SubmitVideoUpdateBody = z.infer<typeof submitVideoUpdateSchema>;

export type SubmitVideoUpdateResponse = {
  success: boolean;
};

export const createEternalChallengeProjectSchema = createEternalProjectSchema;
export type CreateEternalChallengeProjectBody = z.infer<
  typeof createEternalChallengeProjectSchema
>;

export type CreateEternalChallengeProjectResponse = {
  message: string;
};

export const editEternalChallengeProjectSchema = createEternalProjectSchema;
export type EditEternalChallengeProjectBody = z.infer<
  typeof editEternalChallengeProjectSchema
>;

export type EditEternalChallengeProjectResponse = {
  message: string;
};
